import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    ChatBubbleOutline,
    Group,
    LightbulbOutlined,
    ErrorOutline,
    PersonOutline,
    Restaurant,
    CheckCircleOutline
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 1, sm: 3 } }}>
            {/* 目次 */}
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで良好な関係を築く意義
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('basic-tips')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    良好な関係を築くための基本コミュニケーション術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-prevention')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    トラブルを防ぐ話し方・伝え方のコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('distance')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    距離感の取り方とプライバシーの守り方
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experiences')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    体験談で学ぶ成功のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{
                                    minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5',
                                    color: '#888', fontWeight: 'bold', borderRadius: 1,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem'
                                }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')}
                                    color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ：ルームシェアを楽しむためのヒント
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで良好な関係を築く意義
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、住まいの多様化が進む中で、ルームシェアは単なる「家賃を抑える手段」から「人と人とのつながりを楽しむ新しい暮らし方」へと進化しています。しかし、赤の他人が一つ屋根の下で暮らすからこそ、コミュニケーションの質が住み心地を大きく左右します。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    この記事では、ルームシェアを円満かつ快適に楽しむための「おすすめコミュニケーション術」をプロの視点で徹底解説。トラブルを未然に防ぐコツや、心地よい距離感の作り方、体験談を交えながら、あなたのシェア生活をより充実させるヒントをお届けします。
                </Typography>

                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 3,
                        mb: 1
                    }}
                >
                    
                </Box>
            </Box>

            {/* 良好な関係を築くための基本コミュニケーション術 */}
            <Box id="basic-tips" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    良好な関係を築くための基本コミュニケーション術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ChatBubbleOutline sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>日々の挨拶を大切に</Typography>
                            </Box>
                            <Typography variant="body2">
                                「おはよう」「お疲れさま」などの一言は、信頼関係の土台です。忙しいときでも笑顔で声をかけ合う習慣が、円滑な雰囲気を生み出します。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Group sx={{ color: 'primary.main', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>ルールや期待を共有</Typography>
                            </Box>
                            <Typography variant="body2">
                                共有スペースの使い方や掃除の分担、静かにしてほしい時間帯など、小さなことでも最初にすり合わせることが大切です。話しやすい雰囲気づくりがポイント。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                        実践したいポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="相手の話にしっかり耳を傾け、否定せずに受け止める" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="LINEグループや掲示板で連絡事項を共有する" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><CheckCircleOutline color="success" /></ListItemIcon>
                            <ListItemText primary="時々、みんなで食事やイベントを楽しむ" />
                        </ListItem>
                    </List>
                </Box>
            </Box>

            {/* トラブルを防ぐ話し方・伝え方のコツ */}
            <Box id="trouble-prevention" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    トラブルを防ぐ話し方・伝え方のコツ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <ErrorOutline sx={{ color: 'error.main', mr: 1 }} />
                    <Typography variant="body1" sx={{ fontWeight: 700 }}>
                        ちょっとした言い方の違いが、大きなすれ違いに発展することも
                    </Typography>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                    例えば「掃除ができていない」と指摘したいとき、感情的にならず、相手を責めない表現を意識しましょう。伝え方一つで、相手の受け止め方も大きく変わります。
                </Typography>
                <Box sx={{ my: 2, ml: 2, pl: 2, borderLeft: '4px solid #64b5f6' }}>
                    <Typography variant="body2">
                        <b>NG例：</b>「なんで掃除してくれないの？」
                        <br />
                        <b>OK例：</b>「最近忙しい？もし手が回らなかったら、私も手伝うよ」
                    </Typography>
                </Box>
                <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                        トラブルを防ぐためのチェックリスト
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><LightbulbOutlined color="primary" /></ListItemIcon>
                            <ListItemText primary="主語は“自分”にする（Iメッセージ）" secondary="例：『私はこう思う』『私はこうしてほしい』" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><LightbulbOutlined color="primary" /></ListItemIcon>
                            <ListItemText primary="感情をストレートにぶつけない" secondary="一呼吸おいて落ち着いて伝える" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><LightbulbOutlined color="primary" /></ListItemIcon>
                            <ListItemText primary="提案・代案を添える" secondary="『もしよければ今度一緒にやろう』など" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><LightbulbOutlined color="primary" /></ListItemIcon>
                            <ListItemText primary="文字で残すときも柔らかい表現を意識する" />
                        </ListItem>
                    </List>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 3,
                        mb: 1
                    }}
                >
                    <img
                        src="/images/blog/communication-note_roomshare-osusume-communication.jpg"
                        alt="ルームメイト同士がリビングのテーブルを囲み、和やかに意見交換をしている様子。カラフルなメモ帳やペンが並び、建設的なコミュニケーションを象徴しているシーン。"
                        style={{
                            borderRadius: 12,
                            maxWidth: '100%',
                            boxShadow: '0 2px 16px rgba(33, 150, 243, 0.09)'
                        }}
                    />
                </Box>
            </Box>

            {/* 距離感の取り方とプライバシーの守り方 */}
            <Box id="distance" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    距離感の取り方とプライバシーの守り方
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    一緒に暮らしているからといって、常にべったりでいる必要はありません。むしろ、適度な距離感があるからこそ、長く快適に過ごせるのです。
                </Typography>
                <Paper elevation={0} sx={{ bgcolor: '#fafafa', p: 2, borderRadius: 2, mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        距離感を保つためのポイント
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon><PersonOutline color="action" /></ListItemIcon>
                            <ListItemText primary="個室やパーソナルスペースを大切にする" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><PersonOutline color="action" /></ListItemIcon>
                            <ListItemText primary="無理に交流を強要しない（誘いは断ってもOK）" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><PersonOutline color="action" /></ListItemIcon>
                            <ListItemText primary="イヤホンや“在宅ワーク中”サインで暗黙の合図をつくる" />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2">
                    それぞれのライフスタイルや性格に理解を示しつつ、「一人の時間」も尊重し合いましょう。時に距離を置くことが、より良い関係を保つ秘訣です。
                </Typography>
            </Box>

            {/* 体験談で学ぶ成功のポイント */}
            <Box id="experiences" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    体験談で学ぶ成功のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    実際にルームシェアで成功している方々のエピソードから、コミュニケーションのヒントを学びましょう。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar sx={{ mr: 1 }} src="/images/avatars/share-voice1.jpg" alt="20代女性の笑顔のポートレート" />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Aさん（20代女性）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「仕事で疲れて帰宅した時、リビングでの『おかえり』が本当にうれしいんです。小さな気遣いが毎日の安心感につながっています。」
                                </Typography>
                                <Chip label="日々の声かけ" color="primary" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar sx={{ mr: 1 }} src="/images/avatars/share-voice2.jpg" alt="30代男性の自然な表情のプロフィール写真" />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Bさん（30代男性）</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「掃除やゴミ出しの分担で少し意見が食い違った時も、直接話し合って解決できたことで、むしろ信頼が深まりました。」
                                </Typography>
                                <Chip label="素直な話し合い" color="secondary" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        mt: 3
                    }}
                >
                    <img
                        src="/images/blog/share-dinner_roomshare-osusume-communication.jpg"
                        alt="カラフルな料理を囲みながら複数のルームメイトが笑顔で食事を楽しんでいる夕食の風景。暖かい照明とアットホームな雰囲気が、ルームシェアの交流の豊かさを表現している。"
                        style={{
                            borderRadius: 12,
                            maxWidth: '100%',
                            boxShadow: '0 2px 16px rgba(33, 150, 243, 0.09)'
                        }}
                    />
                </Box>
                <Typography variant="body2" sx={{ mt: 3 }}>
                    体験談から分かるのは、完璧な関係を目指すよりも、互いの違いを受け入れ、率直に話し合う姿勢が大切だということです。
                </Typography>
            </Box>

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ：ルームシェアを楽しむためのヒント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2, bgcolor: '#f1f8e9' }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ルームシェアは、相手との心地よいコミュニケーションがあってこそ、安心して過ごせる場所になります。挨拶やルールの共有、丁寧な伝え方、そして適度な距離感を意識すれば、毎日がもっと豊かで楽しいものになるはずです。
                    </Typography>
                    <Typography variant="body2">
                        「違い」を受け入れ合い、気軽に話し合える関係を築くことが、トラブルのない快適なシェア生活の最大のコツです。
                    </Typography>
                </Paper>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption" display="block" sx={{ mb: 1 }}>
                        この記事があなたのルームシェア生活の参考になれば幸いです。
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-osusume-communication',
    slug: 'roomshare-osusume-communication',
    title: 'ルームシェアの「おすすめコミュニケーション術」',
    excerpt: '良好な関係を築くコツ、トラブルを防ぐ話し方、距離感の取り方、体験談を専門家の視点で解説します。',
    coverImage: '/images/blog/cover-roomshare-communication_roomshare-osusume-communication.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。ウッド調の家具と観葉植物、笑顔があふれる雰囲気が調和し、快適な共同生活の魅力を象徴している。',
    publishedAt: '2024-06-15T09:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', 'ライフスタイル', 'コミュニケーション'],
    tags: ['ルームシェア', '共同生活', '人間関係', 'トラブル防止', '快適な暮らし'],
    author: {
        name: '高橋 直人',
        avatar: '/images/avatars/naoto-takahashi.jpg',
        bio: '住まいとコミュニティ分野の執筆歴15年。多数のルームシェア案件やシェアハウス設計にも携わる。人と人が心地よく暮らせるためのノウハウを発信中。',
        profilePicture: '/images/avatars/naoto-takahashi.jpg'
    },
    viewCount: 1525,
    contentComponent: PostContent
};

export default post;